import { useMemo } from "react";
import { useGetPatientTaskByTypeQuery } from "src/api/services/tasksApi";
import ActionItem from "src/pages/PatientDashboard/components/ActionItems/components/ActionItem";
import WhiteCard from "src/shared/components/WhiteCard";

const ReactivateMembershipActionItem = () => {
  const { data } = useGetPatientTaskByTypeQuery("REACTIVATE_MEMBERSHIP");

  const item = useMemo(() => {
    if (data == null) return null;

    return data;
  }, [data]);

  if (item == null) return null;

  return (
    <WhiteCard gap={2}>
      <ActionItem item={item} />
    </WhiteCard>
  );
};

export default ReactivateMembershipActionItem;
